import apiClient from './client';

function resolveStoredToken(rawToken) {
  if (!rawToken) {
    return null;
  }

  const attemptObjectResolve = (value) => {
    if (!value || typeof value !== 'object') {
      return null;
    }
    if (value.token !== undefined) {
      return resolveStoredToken(value.token);
    }
    if (value.accessToken !== undefined) {
      return resolveStoredToken(value.accessToken);
    }
    return null;
  };

  if (typeof rawToken === 'string') {
    const trimmed = rawToken.trim();
    if (!trimmed || trimmed === 'null' || trimmed === 'undefined') {
      return null;
    }

    try {
      const parsed = JSON.parse(trimmed);
      const resolved = attemptObjectResolve(parsed);
      if (resolved) {
        return resolved;
      }
      if (typeof parsed === 'string') {
        return parsed.trim() || null;
      }
    } catch (error) {
      // Not JSON, fall through to returning the trimmed string.
    }

    return trimmed;
  }

  return attemptObjectResolve(rawToken);
}

function adminAuthHeaders() {
  if (typeof window === 'undefined') return {};
  const stored = window.localStorage.getItem('asi:admin-token');
  const token = resolveStoredToken(stored);
  if (!token) return {};
  return {
    Authorization: `Bearer ${token}`,
  };
}

export function fetchDashboardOverview() {
  return apiClient.get('/admin/dashboard/overview', {
    headers: adminAuthHeaders(),
  });
}

export function fetchCustomers(params) {
  return apiClient.get('/admin/customers', {
    params,
    headers: adminAuthHeaders(),
  });
}

export function fetchCustomerDetail(userId) {
  return apiClient.get(`/admin/customers/${userId}`, {
    headers: adminAuthHeaders(),
  });
}

export function updateCustomerProfile(userId, payload) {
  return apiClient.patch(`/admin/customers/${userId}/profile`, payload, {
    headers: adminAuthHeaders(),
  });
}

export function deleteCustomer(userId) {
  return apiClient.delete(`/admin/customers/${userId}`, {
    headers: adminAuthHeaders(),
  });
}

export function fetchProducts() {
  return apiClient.get('/admin/products', {
    headers: adminAuthHeaders(),
  });
}

export function fetchGenerationModels() {
  return apiClient.get('/admin/generation-models', {
    headers: adminAuthHeaders(),
  });
}

export function createProduct(payload) {
  return apiClient.post('/admin/products', payload, {
    headers: adminAuthHeaders(),
  });
}

export function updateProduct(productId, payload) {
  return apiClient.patch(`/admin/products/${productId}`, payload, {
    headers: adminAuthHeaders(),
  });
}

export function updateGenerationModel(modelKey, payload) {
  return apiClient.patch(`/admin/generation-models/${modelKey}`, payload, {
    headers: adminAuthHeaders(),
  });
}

export function reorderGenerationModels(items) {
  return apiClient.patch('/admin/generation-models-sort-order', { items }, {
    headers: adminAuthHeaders(),
  });
}

export function assignSubscription(payload) {
  return apiClient.post('/admin/subscriptions', payload, {
    headers: adminAuthHeaders(),
  });
}

export function createSubscriptionRequest(payload) {
  return apiClient.post('/admin/subscription-requests', payload, {
    headers: adminAuthHeaders(),
  });
}

export function fetchSubscriptionRequests(params) {
  return apiClient.get('/admin/subscription-requests', {
    params,
    headers: adminAuthHeaders(),
  });
}

export function updateSubscriptionRequest(requestId, payload) {
  return apiClient.patch(`/admin/subscription-requests/${requestId}`, payload, {
    headers: adminAuthHeaders(),
  });
}

export function fetchAdmins(params) {
  return apiClient.get('/admin/admins', {
    params,
    headers: adminAuthHeaders(),
  });
}

export function updateAdmin(adminId, payload) {
  return apiClient.patch(`/admin/admins/${adminId}`, payload, {
    headers: adminAuthHeaders(),
  });
}

export function deleteAdmin(adminId) {
  return apiClient.delete(`/admin/admins/${adminId}`, {
    headers: adminAuthHeaders(),
  });
}

export function fetchCollections(params) {
  return apiClient.get('/admin/collections', {
    params,
    headers: adminAuthHeaders(),
  });
}

export function updateCollection(collectionId, payload) {
  return apiClient.patch(`/admin/collections/${collectionId}`, payload, {
    headers: adminAuthHeaders(),
  });
}

export function reorderCollections(items) {
  return apiClient.patch('/admin/collections-sort-order', { items }, {
    headers: adminAuthHeaders(),
  });
}
